import * as types from './types';

export const getUserNotificationSettingsRequest = (data) => ({ type: types.GET_USER_NOTIFICATION_SETTINGS_REQUEST, data });
export const getUserNotificationSettingsRequestFailure = (error) => ({ type: types.GET_USER_NOTIFICATION_SETTINGS_REQUEST_FAILURE, error });
export const getUserNotificationSettingsRequestSuccess = (data) => ({ type: types.GET_USER_NOTIFICATION_SETTINGS_REQUEST_SUCCESS, data });

export const updateUserNotificationSettingsRequest = (data) => ({ type: types.UPDATE_USER_NOTIFICATION_SETTINGS_REQUEST, data });
export const updateUserNotificationSettingsRequestFailure = (error) => ({
  type: types.UPDATE_USER_NOTIFICATION_SETTINGS_REQUEST_FAILURE,
  error,
});
export const updateUserNotificationSettingsRequestSuccess = (data) => ({
  type: types.UPDATE_USER_NOTIFICATION_SETTINGS_REQUEST_SUCCESS,
  data,
});
